import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AgencyAddressModel } from 'src/app/account/agency-address';

@Injectable()
export class AgencyAddressSharingService {
  private address: BehaviorSubject<AgencyAddressModel> = new BehaviorSubject(new AgencyAddressModel());
  agencyAddress = this.address.asObservable();

  assignAgencyAddress(address: AgencyAddressModel) {
    this.address.next(address);
  }
}
